import React from 'react';

interface Props {
  size?: number;
}

export const LoadingLogoComponent: React.FC<Props> = ({ size }) => {
  return (
    <div className="flex flex-col items-center">
      <img
        style={{ height: size ? size : 50, width: size ? size : 50 }}
        className={`opacity-50  animate-spin-slow `}
        src="/assets/icons/gray-bg/fullGuarantee.svg"
        alt="Loading spinner"
      />
    </div>
  );
};
